export default __webpack_public_path__ + "static/media/walla-black.8d159c08.svg";